import Box from "@mui/material/Box"
import { styled } from "@mui/material/styles"

import { SortableHeaderCell } from "../../../common/components/tables/cells"
import AIIncludedIcon from "./AI-IncludedIcon"

export default function LikelihoodToMoveHeaderTableCell({
  sortColumn,
  sortDirection,
  onSortColumnChanged,
}) {
  return (
    <SortableHeaderCell
      columnName="likelihood_to_move"
      label="Potential"
      sortColumn={sortColumn}
      sortDirection={sortDirection}
      onClick={onSortColumnChanged}
    >
      <Box sx={{ width: "12px" }} />
      <IconContainer>
        <AIIncludedIcon sx={{ fontSize: "14px" }} />
      </IconContainer>
    </SortableHeaderCell>
  )
}

const IconContainer = styled((props) => <Box component="span" {...props} />)(
  () => ({
    position: "absolute",
    top: "-4px",
    right: "22px",
  })
)
